module.exports = __webpack_public_path__ + "img/6-large.54e15bbd.jpg";